/* CIBanner — Clinical Intelligence inline banner (iter 96b).
 *
 * Small contextual nudge rendered NEXT to a specific field (not in the
 * sidebar). Three tones:
 *   - 'info'   → blue, neutral nudge (e.g. "Arch balance ✓")
 *   - 'warn'   → amber, value outside the recommended range
 *   - 'block'  → rose, value will block submit until corrected
 *
 * Self-hides when `show` is false. Designed for one-line guidance — keep
 * messages short. Long messages can use `secondary` for a quieter helper line.
 */
import React from "react";
import { Info, Warning, XCircle, CheckCircle } from "@phosphor-icons/react";


const TONES = {
    info: {
        wrap: "bg-blue-50 border-blue-200 text-blue-900",
        Icon: Info,
    },
    success: {
        wrap: "bg-emerald-50 border-emerald-200 text-emerald-900",
        Icon: CheckCircle,
    },
    warn: {
        wrap: "bg-amber-50 border-amber-200 text-amber-900",
        Icon: Warning,
    },
    block: {
        wrap: "bg-rose-50 border-rose-200 text-rose-900",
        Icon: XCircle,
    },
};


export default function CIBanner({ kind = "info", show = true, message, secondary, testId }) {
    if (!show || !message) return null;
    const t = TONES[kind] || TONES.info;
    const Icon = t.Icon;
    return (
        <div
            data-testid={testId || `ci-banner-${kind}`}
            className={`mt-1.5 rounded-lg border px-3 py-1.5 flex items-start gap-2 text-[11px] leading-snug ${t.wrap}`}
        >
            <Icon size={13} weight="bold" className="shrink-0 mt-0.5" />
            <div className="min-w-0">
                <div className="font-semibold">{message}</div>
                {secondary && <div className="text-[10px] opacity-80 mt-0.5">{secondary}</div>}
            </div>
        </div>
    );
}
